import { render, staticRenderFns } from "./TeacherDepartments.vue?vue&type=template&id=15899d9a"
import script from "./TeacherDepartments.vue?vue&type=script&lang=js"
export * from "./TeacherDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports